export default __webpack_public_path__ + "static/media/avatar.b08c7447.png";